import {
  Root,
  Thumb,
  SwitchProps as RadixSwitchProps,
} from '@radix-ui/react-switch';
import { clsx } from 'clsx';
import {
  switchRoot,
  switchRootSizes,
  switchThumb,
  switchThumbSizes,
  type SwitchSize,
} from './switch.css.ts';

export type SwitchProps = RadixSwitchProps & {
  inversed?: boolean;
  size?: SwitchSize;
};

export const Switch = function CheckboxComponent({
  ref,
  children,
  className,
  inversed,
  size = 'md',
  ...rest
}: SwitchProps & {
  ref?: React.Ref<HTMLButtonElement>;
}) {
  return (
    <Root
      ref={ref}
      data-inversed={inversed ? '' : undefined}
      className={clsx(className, switchRoot, switchRootSizes[size])}
      {...rest}
    >
      <Thumb className={clsx(switchThumb, switchThumbSizes[size])}>
        {children}
      </Thumb>
    </Root>
  );
};
